import { ContactConfig } from "./contact.types";

export const contactConfig: ContactConfig = {
  companyName: "on[c:orange]*[/c]arte",
  address: `ul. Garbary 67 
    61-758 Poznań`,
  phone: "+48 695 196 591",
  collaborationEmail: "hello@onarte.pl",
};
